import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import CustomModal from './Modal/CustomModal';
import {FILE_TYPE} from '../Helpers/fileType';
import {ACTION_MODEL} from '../Helpers/ActionModel';
import {getPhotoPicker, PHOTO_PICKER_MODEL, SUGGESTION_MODE_OPTION} from './PhotoPicker/SubComponent/Models/Models';
import CustomPhotoPicker from './PhotoPicker/CustomPhotoPicker';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.m
 *
 * @param string title: title modal
 * @param boolean showPreview: default value is true, must be set to false if preview visualization is not needed with the upload component
 * @param model photoPicker: component model
 * @param useState setPhotoPicker: state to update the component model
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 */
const UploadImageModal = (props) => {
    const { title, photoPicker, setPhotoPicker, validateFace=false, showBtnCamera=true,fileType,showPreview } = props;
    const { t } = useTranslation();

    const [photoPickerAux, setPhotoPickerAux] = useState({ ...PHOTO_PICKER_MODEL });
    const [emptyFields, setEmptyFields] = useState(false);
    const [displayModal, setDisplayModal] = useState("")
    const [disabled, setDisabled] = useState(true)

    useEffect(() => {
        setPhotoPickerAux({ ...PHOTO_PICKER_MODEL, preview: photoPicker.preview })
        setDisabled(true)
    }, [props.show]);

    useEffect(() => {
        if(photoPickerAux?.fileSelected != null){
            setEmptyFields(false);
        }
    }, [photoPickerAux]);

    useEffect(() => {
        setDisabled(!getPhotoPicker(photoPickerAux));
    }, [photoPickerAux]);

    const handleUploadImageAction = () => {
        let picker = getPhotoPicker(photoPickerAux)
        if(picker == null ){
            setEmptyFields(true);
            return;
        }
        setPhotoPicker({...photoPickerAux})
        props.onHide();
    };
    return (
        <>
            <CustomModal
                title={title}
                size='lg'
                {...props}
                display={displayModal}
                onConfirm={() => { handleUploadImageAction(); }}
                onHide={()=>{
                    setEmptyFields(false);
                    setPhotoPicker({ ...PHOTO_PICKER_MODEL, preview: photoPicker.preview })
                    props.onHide();
                }}
                disabled={disabled}
                classNameBody={'w-100'}
            >
                <CustomPhotoPicker
                    id='fp_uim_create_image_vehicle'
                    photoPicker={photoPickerAux}
                    setPhotoPicker={setPhotoPickerAux}
                    actionModel={ACTION_MODEL.CREATE}
                    accept={{ ...fileType }}
                    classWith={'w-100'}
                    required={true}
                    emptyFields={emptyFields}
                    validateFace={validateFace}
                    showBtnCamera={showBtnCamera}
                    typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE}
                    setDisplayModal={setDisplayModal}
                    showPreview={showPreview}
                />
            </CustomModal>
        </>
    );
};
export default UploadImageModal;
